import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryExporterModal`

export default defineMessages({
  budgetsExporterModalTitle: {
    id: `${scope}.budgetsExporterModalTitle`,
    defaultMessage: 'Export budgets',
  },
  budgetCategoryExporterModalTitle: {
    id: `${scope}.budgetCategoryExporterModalTitle`,
    defaultMessage: 'Export budget categories',
  },
  includeSpendToggleLabel: {
    id: `${scope}.includeSpendToggleLabel`,
    defaultMessage: 'Include spend',
  },
  budgetDateRangeLabel: {
    id: `${scope}.budgetDateRangeLabel`,
    defaultMessage: 'Budget date range',
  },
  budgetsToExportLabel: {
    id: `${scope}.budgetsToExportLabel`,
    defaultMessage: 'Budgets to export',
  },
  budgetCategoriesToExportLabel: {
    id: `${scope}.budgetCategoriesToExportLabel`,
    defaultMessage: 'Budget categories to export',
  },
})
